// extracted by mini-css-extract-plugin
module.exports = {"root":"📦Tag__root--2UZsp","danger":"📦Tag__danger--ZTPfY","warning":"📦Tag__warning--1zvmY","info":"📦Tag__info--1qDHj"};